import React, { useEffect, useState } from "react";
import { render } from "react-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper";

(function init() {
  const selectors = {
    root: "[logo-swiper]",
  };

  const rootElement = document.querySelector(selectors.root);

  if (!rootElement) return;

  render(<LogoCarousle />, rootElement);
})();

function LogoCarousle() {
  const media = JSON.parse(document.querySelector("[data-media]").innerHTML);
  const [selectedMedia, setSelectedMedia] = useState(0);
  const swiperRef = React.useRef(null);
  const [swiper, setSwiper] = useState();

  useEffect(() => {
    const intervalID = setInterval(() => {
      if (selectedMedia === media.length - 1) {
        setSelectedMedia(0);
      } else {
        setSelectedMedia(selectedMedia + 1);
      }
    }, 3000);

    return () => clearInterval(intervalID);
  }, [selectedMedia]);

  return (
    <>
      <div className="md:block hidden">
        <p className="text-center text-white text-xl pt-10 pb-20 leading-10">
          {media[selectedMedia].quote}
        </p>
        <div className="md:flex md:justify-around md:flex-wrap md:gap-y-16">
          {media.map((m, index) => {
            return (
              <>
                <button
                  className=""
                  onClick={(e) => {
                    setSelectedMedia(index);
                  }}
                >
                  <img
                    className={`bg-black w-10/12 ${
                      selectedMedia === index ? "opacity-100" : "opacity-20"
                    }`}
                    src={m.image}
                  />
                </button>
              </>
            );
          })}
        </div>
      </div>

      <div className=" md:hidden">
        <Swiper
          ref={swiperRef}
          onInit={(ev) => {
            setSwiper(ev);
          }}
          loop={media.length > 1}
          autoplay={{
            disableOnInteraction: true,
          }}
          pagination={{
            clickable: true,
            
          }}
          modules={[Pagination, Autoplay]}
          slidesPerView={1}
          watchOverflow={true}
          className="swiper swiper--full-height"
          style={{
            "--swiper-navigation-color": "#000",
            "--swiper-pagination-color": "#fff",
          }}
        >
          {media.map((m, index) => {
            return (
              <SwiperSlide className="!w-[10vw]\">
                <p className="text-center text-white pt-10 pb-20 leading-10 w-11/12 m-auto">
                  {media[index].quote}
                </p>
                <img className="bg-black opacity-100 m-auto" src={m.image} />
              </SwiperSlide>
            );
          })}
          <div className="swiper-pagination text-center">hello</div>
        </Swiper>
      </div>
    </>
  );
}
